module.exports = __webpack_public_path__ + "img/header-icon.3003edee.svg";